import { lazy } from "react";

const PreferencesPopup = lazy(() => import("@/components/popups/PreferencesPopup"));
const ChangedEmailPopup = lazy(() => import("@/components/popups/ChangedEmailPopup"));
const AddToNichePopup = lazy(() => import("@/components/popups/AddToNichePopup"));
const ReportPopup = lazy(() => import("@/components/popups/Report"));
const AddToCollectionPopup = lazy(() => import("@/components/popups/AddToCollectionPopup"));
const CreateNewCollectionPopup = lazy(() => import("@/components/popups/CreateNewCollectionPopup"));
const EditNichePopup = lazy(() => import("@/components/popups/EditNichePopup"));
const EditNichesDialog = lazy(() => import("@/components/popups/EditNichesDialog"));
const GifPreferencePopup = lazy(() => import("@/components/popups/GifPreferencePopup"));
const ShareGifMenu = lazy(() => import("@/components/popups/ShareMenu"));
const MoreMenu = lazy(() => import("@/components/popups/MoreMenu"));
const NicheMoreMenu = lazy(() => import("@/components/popups/NicheMoreMenu"));
const EditGifPopup = lazy(() => import("@/components/popups/EditGifPopup"));
const AddToNicheSuccessPopup = lazy(() => import("@/components/popups/AddToNicheSuccessPopup"));
const AddDescriptionPopup = lazy(() => import("@/components/popups/AddDescriptionPopup"));
const VerificationPopup = lazy(() => import("@/components/popups/VerificationPopup"));
const GifNichesPopup = lazy(() => import("@/components/popups/GifNichesPopup"));
const ProfileOptions = lazy(() => import("@/components/popups/ProfileOptions"));
const DeleteAccount = lazy(() => import("@/components/popups/DeleteAccount"));
const AddToNicheConfirm = lazy(() => import("@/components/popups/AddToNicheConfirm"));
const CreateNichePopup = lazy(() => import("@/components/popups/CreateNichePopup"));
const CaptchaPopup = lazy(() => import("@/components/popups/CaptchaPopup"));

export enum PopupsEnum {
  Preferences = "preferences",
  ChangedEmail = "changedEmail",
  AddNiche = "addNiche",
  Report = "report",
  AddCollection = "addCollection",
  CreateCollection = "createCollection",
  EditNiche = "editNiche",
  EditGifNiches = "editGifNiches",
  EditGifPreferences = "editGifPreferences",
  ShareGif = "shareGif",
  MoreMenu = "moreMenu",
  EditGif = "editGif",
  NicheMoreMenu= "nicheMoreMenu",
  AddToNicheSuccess= "addToNicheSuccess",
  AddDescriptionPopup= "addDescriptionPopup",
  AddToNicheConfirm= "addToNicheConfirm",
  CreateNiche= "createNiche",
  CaptchaPopup= "captchaPopup",
  Verification = "verification",
  GifNiches = "gifNiches",
  ProfileOptions = "profileOptions",
  DeleteAccount = "deleteAccount"
}

export const popups = {
  [PopupsEnum.Preferences]: PreferencesPopup,
  [PopupsEnum.ChangedEmail]: ChangedEmailPopup,
  [PopupsEnum.AddNiche]: AddToNichePopup,
  [PopupsEnum.Report]: ReportPopup,
  [PopupsEnum.AddCollection]: AddToCollectionPopup,
  [PopupsEnum.CreateCollection]: CreateNewCollectionPopup,
  [PopupsEnum.EditNiche]: EditNichePopup,
  [PopupsEnum.EditGifNiches]: EditNichesDialog,
  [PopupsEnum.EditGifPreferences]: GifPreferencePopup,
  [PopupsEnum.ShareGif]: ShareGifMenu,
  [PopupsEnum.MoreMenu]: MoreMenu,
  [PopupsEnum.EditGif]: EditGifPopup,
  [PopupsEnum.NicheMoreMenu]: NicheMoreMenu,
  [PopupsEnum.AddToNicheSuccess]: AddToNicheSuccessPopup,
  [PopupsEnum.AddDescriptionPopup]: AddDescriptionPopup,
  [PopupsEnum.AddToNicheConfirm]: AddToNicheConfirm,
  [PopupsEnum.Verification]: VerificationPopup,
  [PopupsEnum.GifNiches]: GifNichesPopup,
  [PopupsEnum.ProfileOptions]: ProfileOptions,
  [PopupsEnum.DeleteAccount]: DeleteAccount,
  [PopupsEnum.CreateNiche]: CreateNichePopup,
  [PopupsEnum.CaptchaPopup]: CaptchaPopup,
};
